<template>
    <div class="load" >
        <van-loading color="#1989fa" vertical/>
    </div>
</template>
<script>
    export default {

    }
</script>
<style lang="less" scoped>
/deep/ .van-loading {
    color: #c8c9cc;
    font-size: 0;
    height: 100%;
    position: fixed;
    width: 100%;
    opacity: 1;
    opacity: 1;
}
/deep/ .van-loading__spinner {
    position: absolute;
    top: 50%;
    display: inline-block;
    width: 0.8rem;
    max-width: 100%;
    height: 0.8rem;
    max-height: 100%;
    -webkit-animation: van-rotate .8s linear infinite;
    animation: van-rotate .8s linear infinite;
}
</style>
